export const SPRING = {
  type: "spring",
  stiffness: 55,
  damping: 18
};

export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: SPRING
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12 }
  }
};

export const staggerChild = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: SPRING }
};

export const wordReveal = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

export const hoverCard = {
  whileHover: { y: -4, transition: { duration: 0.2 } }
};

export const breathe = {
  animate: { scale: [1, 1.15, 1] },
  transition: { duration: 6, repeat: Infinity, ease: "easeInOut" }
};
